module.exports = __webpack_public_path__ + "img/fj.7501b3d8.svg";